import { Tag } from "@chakra-ui/react";
import { PlanStatus } from "@syla/shared/types/helpers/subscriptions";
import React from "react";

interface PlanStatusTagProps {
  status: PlanStatus;
}

const statusColorMap: Record<Exclude<PlanStatus, "None">, string> = {
  [PlanStatus.Active]: "green",
  [PlanStatus.DowngradeScheduled]: "yellow",
  [PlanStatus.Cancelled]: "red",
  [PlanStatus.Expired]: "red",
  [PlanStatus.RequiresAction]: "red",
};

export const PlanStatusTag = ({ status }: PlanStatusTagProps) => {
  if (status === "None") {
    return null;
  }

  return (
    <Tag variant="subtle" colorScheme={statusColorMap[status]}>
      {status}
    </Tag>
  );
};
